import React from 'react'
import Img from "gatsby-image";

import HeroSmall from '../components/HeroSmall'
import LocationMicroNav from '../components/LocationMicroNav'
import LocationContent from '../components/LocationContent'
import LocationRelated from '../components/LocationRelated'

class ArizonaLocation extends React.Component {
  render() {
    return (
      <div>
        <HeroSmall location="Arizona" />
        <LocationMicroNav />

        { /* Arizona, Story 1 */ }
        <LocationContent 
          category="Promoting Ridership" 
          title="Clear Eyes, Open Streets, Can't Lose"
          story="We revere events that appeal to all types of bike riders, which is why one of our favorite trips of the year was a visit to Tucson for Ciclovia, their open streets event. Tucson is one of our 10 Big Jump Cities, and the 2017 Ciclovia featured a longer (four-mile) route along a big commercial street. More than 25,000 people showed up to pedal or walk—their best attended event to date."
        />  
        <Img
          title="Arizona 1-2"
          alt="Ciclovia event in Tucson"
          sizes= { this.props.data.arizonaOneTwoImage.sizes }
        />  

        { /* Arizona, Story 2 */ }
        <LocationContent 
          category="Bike Biz" 
          title="New Partners for New Business"
          story="PeopleForBikes’ president Tim Blumenthal moderated a panel session at the Independent Bicycle Dealers (IBD) Summit in Tempe. The focus was on new paths to better business for bicycle retailers. Panelists discussed partnerships with the mass market segment of the bike business, the importance of big recreational bike rides, and the potential of bike sharing to get more people riding."
        />  
        <Img
          title="Arizona 2-1"
          alt="People for Bikes at the Independent Bicycle Dealers (IBD) Summit in Tempe"
          sizes= { this.props.data.arizonaTwoOneImage.sizes }
        />   
      
        <LocationRelated 
          prevLocationName="Wichita, KS"
          prevLocationPath="wichita"
          prevLocationImgPath= { this.props.data.arizonaPrevImage }
          nextLocationName="Albany, NY"
          nextLocationPath="albany"
          nextLocationImgPath= { this.props.data.arizonaNextImage }
        /> 
      </div>
    )
  }
}

export default ArizonaLocation

// GraphQL query
export const arizonaImageQuery = graphql`
  query arizonaImageQuery {
    arizonaOneTwoImage: imageSharp(id: { regex: "/PFB_Arizona_1-2/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    arizonaTwoOneImage: imageSharp(id: { regex: "/PFB_Arizona_2-1/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    arizonaPrevImage: imageSharp(id: { regex: "/PFB_WICHITA/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    arizonaNextImage: imageSharp(id: { regex: "/PFB_ALBANY/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/arizona.js